import UndoNavItem from "views/components/sidebar/undo/UndoNavItem";
import RedoNavItem from "views/components/sidebar/redo/RedoNavItem";
const sidebarActions = [
  {
    key: "undoAction",
    Component: UndoNavItem
  },
  {
    key: "redoAction",
    Component: RedoNavItem
  }
];
export default sidebarActions;
